/**
 * داده‌های ماک برای داشبورد منابع انسانی طبق راهنمای جامع
 * HR_MANAGEMENT_DASHBOARD_FRONTEND_GUIDE.md
 */

export const hrDashboardMockData = {
  today: {
    date: '2026-09-28',
    jalali_date: '1405/07/07',
    total_employees: 32,
    counts: {
      present: 21,
      late: 4,
      leave: 3,
      mission: 2,
      absent: 1,
      day_off: 5,
    },
    lists: {
      present: [
        {
          id: 14,
          name: 'علی رضایی',
          email: 'ali@example.com',
          avatar: '',
          department: 'فنی و توسعه',
          designation: 'برنامه‌نویس ارشد',
          attendance_id: 1052,
          clock_in_time: '08:05',
          clock_out_time: null,
          is_late: false,
        },
        {
          id: 15,
          name: 'مهدی احمدی',
          email: 'mehdi@example.com',
          avatar: '',
          department: 'فنی و توسعه',
          designation: 'توسعه‌دهنده فرانت‌اند',
          attendance_id: 1053,
          clock_in_time: '08:12',
          clock_out_time: null,
          is_late: false,
        },
        {
          id: 16,
          name: 'فاطمه موسوی',
          email: 'fatemeh@example.com',
          avatar: '',
          department: 'طراحی محصول',
          designation: 'طراح رابط کاربری',
          attendance_id: 1054,
          clock_in_time: '08:18',
          clock_out_time: null,
          is_late: false,
        },
        {
          id: 17,
          name: 'حسین مرادی',
          email: 'hossein@example.com',
          avatar: '',
          department: 'مالی',
          designation: 'مدیر مالی',
          attendance_id: 1056,
          clock_in_time: '08:02',
          clock_out_time: null,
          is_late: false,
        },
      ],
      late: [
        {
          id: 18,
          name: 'رضا صادقی',
          email: 'reza@example.com',
          avatar: '',
          department: 'فروش',
          designation: 'کارشناس فروش',
          attendance_id: 1055,
          clock_in_time: '08:42',
          clock_out_time: null,
          is_late: true,
        },
        {
          id: 19,
          name: 'سروش رستمی',
          email: 'soroush@example.com',
          avatar: '',
          department: 'بازاریابی',
          designation: 'کارشناس محتوا',
          attendance_id: 1057,
          clock_in_time: '08:50',
          clock_out_time: null,
          is_late: true,
        },
        {
          id: 20,
          name: 'نگین تهرانی',
          email: 'negin@example.com',
          avatar: '',
          department: 'پشتیبانی',
          designation: 'کارشناس پشتیبانی',
          attendance_id: 1058,
          clock_in_time: '08:35',
          clock_out_time: null,
          is_late: true,
        },
        {
          id: 21,
          name: 'محمدرضا کاظمی',
          email: 'm.kazemi@example.com',
          avatar: '',
          department: 'منابع انسانی',
          designation: 'کارشناس جذب',
          attendance_id: 1059,
          clock_in_time: '08:40',
          clock_out_time: null,
          is_late: true,
        },
      ],
      leave: [
        {
          id: 22,
          name: 'سارا محمدی',
          email: 'sara@example.com',
          avatar: '',
          department: 'پشتیبانی',
          designation: 'سرپرست پشتیبانی',
          leave_id: 48,
          leave_type: 'استحقاقی',
          duration: 'single',
          reason: 'امور شخصی',
        },
        {
          id: 23,
          name: 'امید ابراهیمی',
          email: 'omid@example.com',
          avatar: '',
          department: 'فنی و توسعه',
          designation: 'توسعه‌دهنده بک‌اند',
          leave_id: 49,
          leave_type: 'استعلاجی',
          duration: 'multiple',
          reason: 'سرماخوردگی و استراحت پزشکی',
        },
        {
          id: 24,
          name: 'مونا یوسفی',
          email: 'mona@example.com',
          avatar: '',
          department: 'مالی',
          designation: 'حسابدار',
          leave_id: 50,
          leave_type: 'استحقاقی',
          duration: 'single',
          reason: 'امور اداری و بانکی',
        },
      ],
      mission: [
        {
          id: 25,
          name: 'حسن کمالی',
          email: 'hassan@example.com',
          avatar: '',
          department: 'نصب و استقرار',
          designation: 'کارشناس فنی',
          mission_id: 12,
          destination: 'اصفهان - شعبه مرکزی',
          trip_type: 'برون‌شهری',
          purpose: 'استقرار سرورهای پایگاه داده',
        },
        {
          id: 26,
          name: 'فرزاد نعمتی',
          email: 'farzad@example.com',
          avatar: '',
          department: 'فروش',
          designation: 'سرپرست فروش سازمانی',
          mission_id: 13,
          destination: 'تهران - پارک علم و فناوری',
          trip_type: 'درون‌شهری',
          purpose: 'مذاکره قرارداد سازمانی با مشتری',
        },
      ],
      absent: [
        {
          id: 31,
          name: 'مریم احمدی',
          email: 'maryam@example.com',
          avatar: '',
          department: 'مالی',
          designation: 'حسابدار ارشد',
        },
      ],
      day_off: [
        {
          id: 40,
          name: 'پویا کریمی',
          email: 'pouya@example.com',
          avatar: '',
          department: 'نگهبانی',
          designation: 'نگهبان شیفت ب',
        },
        {
          id: 41,
          name: 'جواد فراهانی',
          email: 'javad@example.com',
          avatar: '',
          department: 'نگهبانی',
          designation: 'نگهبان شیفت الف',
        },
        {
          id: 42,
          name: 'صادق نوروزی',
          email: 'sadegh@example.com',
          avatar: '',
          department: 'تاسیسات',
          designation: 'تکنسین فنی تاسیسات',
        },
        {
          id: 43,
          name: 'سعید عباسی',
          email: 'saeed@example.com',
          avatar: '',
          department: 'حراست',
          designation: 'کارشناس حراست',
        },
        {
          id: 44,
          name: 'داوود قاسمی',
          email: 'davood@example.com',
          avatar: '',
          department: 'پشتیبانی شیفت شب',
          designation: 'پشتیبان شبانه',
        },
      ],
    },
  },
  month: {
    jalali_year: 1405,
    jalali_month: 7,
    month_name: 'مهر',
    start_date: '۱۴۰۵/۰۷/۰۱',
    end_date: '۱۴۰۵/۰۷/۳۰',
    overtime: {
      minutes: 210,
      hours: 3.5,
      formatted: '۰۳:۳۰',
      approved_requests_count: 4,
    },
    deficit: {
      minutes: 75,
      hours: 1.25,
      formatted: '۰۱:۱۵',
    },
    leaves_used: {
      total_days: 8,
      by_type: {
        'استحقاقی': 6,
        'استعلاجی': 2,
      },
    },
    missions: {
      total_missions: 3,
      total_days: 5,
    },
    attendance_rate_percentage: 96.5,
  },
  alerts: {
    total_alerts_count: 13,
    counts: {
      expiring_contracts: 3,
      expiring_probations: 2,
      missing_clock_outs: 4,
      pending_approvals: 4,
      pending_leaves: 2,
      pending_overtime: 1,
      pending_missions: 1,
      pending_regularizations: 0,
    },
    expiring_contracts: [
      {
        user_id: 14,
        name: 'کامران شریفی',
        avatar: '',
        department: 'فروش',
        designation: 'کارشناس فروش',
        contract_end_date: '2026-10-15',
        jalali_contract_end_date: '۱۴۰۵/۰۷/۲۴',
        days_remaining: 17,
        is_expired: false,
        status_text: '۱۷ روز تا پایان قرارداد',
      },
      {
        user_id: 28,
        name: 'سحر کریمی',
        avatar: '',
        department: 'بازاریابی',
        designation: 'کارشناس دیجیتال مارکتینگ',
        contract_end_date: '2026-10-05',
        jalali_contract_end_date: '۱۴۰۵/۰۷/۱۴',
        days_remaining: 7,
        is_expired: false,
        status_text: '۷ روز تا پایان قرارداد',
      },
      {
        user_id: 35,
        name: 'رامین حیدری',
        avatar: '',
        department: 'فنی و زیرساخت',
        designation: 'کارشناس شبکه',
        contract_end_date: '2026-09-25',
        jalali_contract_end_date: '۱۴۰۵/۰۷/۰۴',
        days_remaining: -3,
        is_expired: true,
        status_text: 'منقضی شده (۳ روز پیش)',
      },
    ],
    expiring_probations: [
      {
        user_id: 29,
        name: 'نیلوفر کاظمی',
        avatar: '',
        department: 'توسعه نرم‌افزار',
        designation: 'برنامه‌نویس جونیور',
        probation_end_date: '2026-10-08',
        jalali_probation_end_date: '۱۴۰۵/۰۷/۱۷',
        days_remaining: 10,
        status_text: '۱۰ روز تا پایان دوره آزمایشی',
      },
      {
        user_id: 30,
        name: 'پرهام دانایی',
        avatar: '',
        department: 'پشتیبانی مشتریان',
        designation: 'کارشناس پشتیبانی',
        probation_end_date: '2026-10-12',
        jalali_probation_end_date: '۱۴۰۵/۰۷/۲۱',
        days_remaining: 14,
        status_text: '۱۴ روز تا پایان دوره آزمایشی',
      },
    ],
    missing_clock_outs: [
      {
        attendance_id: 890,
        user_id: 15,
        name: 'امیر قاسمی',
        avatar: '',
        date: '2026-09-26',
        jalali_date: '۱۴۰۵/۰۷/۰۵',
        clock_in_time: '۰۸:۱۰',
      },
      {
        attendance_id: 891,
        user_id: 27,
        name: 'آرش صابری',
        avatar: '',
        date: '2026-09-26',
        jalali_date: '۱۴۰۵/۰۷/۰۵',
        clock_in_time: '۰۸:۴۵',
      },
      {
        attendance_id: 892,
        user_id: 33,
        name: 'مهناز باقری',
        avatar: '',
        date: '2026-09-27',
        jalali_date: '۱۴۰۵/۰۷/۰۶',
        clock_in_time: '۰۸:۳۰',
      },
      {
        attendance_id: 893,
        user_id: 38,
        name: 'سینا خلیلی',
        avatar: '',
        date: '2026-09-27',
        jalali_date: '۱۴۰۵/۰۷/۰۶',
        clock_in_time: '۰۸:۱۵',
      },
    ],
    pending_approvals: {
      leaves: [
        {
          id: 91,
          name: 'زهرا ابراهیمی',
          leave_type: 'استحقاقی',
          jalali_date: '۱۴۰۵/۰۷/۱۰',
          duration: 'یک روزه',
        },
        {
          id: 92,
          name: 'کیوان رحیمی',
          leave_type: 'استعلاجی',
          jalali_date: '۱۴۰۵/۰۷/۰۸',
          duration: 'دو روزه',
        },
      ],
      overtime: [
        {
          id: 45,
          name: 'محسن حسینی',
          jalali_date: '۱۴۰۵/۰۷/۰۶',
          requested_time: '۰۲:۳۰',
          status: 'pending_manager',
        },
      ],
      missions: [
        {
          id: 18,
          name: 'بابک نوری',
          destination: 'شیراز',
          trip_type: 'برون‌شهری',
          start_date: '۱۴۰۵/۰۷/۱۲',
          end_date: '۱۴۰۵/۰۷/۱۴',
          status: 'pending_hr',
        },
      ],
      regularizations: [],
    },
  },
};
